import React, { ReactNode, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { MobileNavigation } from './MobileNavigation';
import { useAuth } from '../../contexts/AuthContext';
import { MessageWidget } from '../UI/MessageWidget';
import { MessageFloatingButton } from '../UI/MessageFloatingButton';
import { useScreenSize } from '../../hooks/useScreenSize';
import { useMessages } from '../../hooks/useMessages';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const { user, logout } = useAuth();
  const { isDesktop } = useScreenSize();
  const { unreadCount } = useMessages();
  const [showMessageWidget, setShowMessageWidget] = useState(false);
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);

  // Vérifier si le chemin actuel est actif
  const isActive = (path: string) => {
    return location.pathname === path;
  };

  // Ne pas afficher le widget sur la page Messages
  const isMessagesPage = location.pathname === '/messages';
  const shouldShowWidget = isDesktop && user && !isMessagesPage;

  return (
    <div className="min-h-screen text-white">
      {/* Sidebar Navigation - Hidden on mobile, collapsible on desktop */}
      <div className={`hidden md:block h-screen cosmic-card border-r border-emerald-700/30 fixed left-0 top-0 z-30 transition-all duration-300 ease-in-out ${
        isSidebarExpanded ? 'w-64' : 'w-20'
      }`}
      onMouseEnter={() => setIsSidebarExpanded(true)}
      onMouseLeave={() => setIsSidebarExpanded(false)}
      >
        <div className="p-4 flex justify-center md:justify-start items-center">
        <div className="h-10 w-10 rounded-full overflow-hidden flex items-center justify-center relative">
          <img
            src="https://i.imgur.com/FKIlY9U.jpeg"
            alt="Jupipotes Logo"
            className="h-10 w-10 object-cover rounded-full animate-pulse border-2 border-emerald-400 shadow-lg"
          />
        </div>
          <h1 className={`ml-3 text-xl font-bold text-emerald-300 transition-opacity duration-300 ${
            isSidebarExpanded ? 'opacity-100' : 'opacity-0'
          } ${isSidebarExpanded ? 'block' : 'hidden'}`}>
            Jupipotes
          </h1>
        </div>

        <nav className="mt-8">
          <ul className="space-y-2">
            <li>
              <Link 
                to="/" 
                className={`flex items-center px-4 py-3 ${isActive('/') ? 'bg-emerald-700/30 border-r-4 border-emerald-500' : 'hover:bg-emerald-800/20'} group relative`}
                title="Accueil"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
                <span className={`ml-3 transition-opacity duration-300 ${
                  isSidebarExpanded ? 'opacity-100' : 'opacity-0'
                } ${isSidebarExpanded ? 'block' : 'hidden'}`}>
                  Accueil
                </span>
                {/* Tooltip pour version collapsed */}
                {!isSidebarExpanded && (
                  <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                    Accueil
                  </div>
                )}
              </Link>
            </li>

            <li>
              {/*
              <Link 
                to="/tokens" 
                className={`flex items-center px-4 py-3 ${isActive('/tokens') ? 'bg-emerald-700/30 border-r-4 border-emerald-500' : 'hover:bg-emerald-800/20'}`}
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="ml-3 hidden md:block">Tokens</span>
              </Link>
              */}
            </li>

            {/* <li>
              <Link 
                to="/communities" 
                className={`flex items-center px-4 py-3 ${isActive('/communities') ? 'bg-emerald-700/30 border-r-4 border-cyan-400' : 'hover:bg-emerald-800/20'} group relative`}
                title="Communautés"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" fill="none" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 12a8 8 0 0116 0" />
                </svg>
                <span className={`ml-3 transition-opacity duration-300 ${
                  isSidebarExpanded ? 'opacity-100' : 'opacity-0'
                } ${isSidebarExpanded ? 'block' : 'hidden'}`}>
                  Communautés
                </span>
                {!isSidebarExpanded && (
                  <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                    Communautés
                  </div>
                )}
              </Link>
            </li> */}
            <li>
              {/*
              <Link 
                to="/nfts" 
                className={`flex items-center px-4 py-3 ${isActive('/nfts') ? 'bg-emerald-700/30 border-r-4 border-emerald-500' : 'hover:bg-emerald-800/20'}`}
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <span className="ml-3 hidden md:block">NFTs</span>
              </Link>
              */}
            </li>

            <li>
              <Link 
                to="/messages" 
                className={`flex items-center px-4 py-3 ${isActive('/messages') ? 'bg-emerald-700/30 border-r-4 border-emerald-500' : 'hover:bg-emerald-800/20'} group relative`}
                title="Messages"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                </svg>
                <span className={`ml-3 transition-opacity duration-300 ${
                  isSidebarExpanded ? 'opacity-100' : 'opacity-0'
                } ${isSidebarExpanded ? 'block' : 'hidden'}`}>
                  Messages
                </span>
                {!isSidebarExpanded && (
                  <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                    Messages
                  </div>
                )}
              </Link>
            </li>

            <li>
              <Link 
                to="/gaming" 
                className={`flex items-center px-4 py-3 ${isActive('/gaming') ? 'bg-emerald-700/30 border-r-4 border-purple-400' : 'hover:bg-emerald-800/20'} group relative`}
                title="Gaming"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
                </svg>
                <span className={`ml-3 transition-opacity duration-300 ${
                  isSidebarExpanded ? 'opacity-100' : 'opacity-0'
                } ${isSidebarExpanded ? 'block' : 'hidden'}`}>
                  Gaming
                </span>
                {!isSidebarExpanded && (
                  <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                    Gaming
                  </div>
                )}
              </Link>
            </li>

            <li>
              <Link 
                to="/settings" 
                className={`flex items-center px-4 py-3 ${isActive('/settings') ? 'bg-emerald-700/30 border-r-4 border-emerald-500' : 'hover:bg-emerald-800/20'} group relative`}
                title="Paramètres"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className={`ml-3 transition-opacity duration-300 ${
                  isSidebarExpanded ? 'opacity-100' : 'opacity-0'
                } ${isSidebarExpanded ? 'block' : 'hidden'}`}>
                  Paramètres
                </span>
                {!isSidebarExpanded && (
                  <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                    Paramètres
                  </div>
                )}
              </Link>
            </li>
            <li>
              <Link 
                to="/JUPResources" 
                className={`flex items-center px-4 py-3 ${isActive('/JUPResources') ? 'bg-emerald-700/30 border-r-4 border-cyan-400' : 'hover:bg-emerald-800/20'} group relative`}
                title="Ressources JUP"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 20h9" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4h9" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4h.01" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 9h16" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 15h16" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 20h.01" />
                </svg>
                <span className={`ml-3 transition-opacity duration-300 ${
                  isSidebarExpanded ? 'opacity-100' : 'opacity-0'
                } ${isSidebarExpanded ? 'block' : 'hidden'}`}>
                  Ressources JUP
                </span>
                {!isSidebarExpanded && (
                  <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                    Ressources JUP
                  </div>
                )}
              </Link>
            </li>

            <li>
              <Link 
                to="/privacy-policy" 
                className={`flex items-center px-4 py-3 ${isActive('/privacy-policy') ? 'bg-emerald-700/30 border-r-4 border-cyan-400' : 'hover:bg-emerald-800/20'} group relative`}
                title="Politique de confidentialité"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                <span className={`ml-3 transition-opacity duration-300 ${
                  isSidebarExpanded ? 'opacity-100' : 'opacity-0'
                } ${isSidebarExpanded ? 'block' : 'hidden'}`}>
                  Politique de confidentialité
                </span>
                {!isSidebarExpanded && (
                  <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                    Politique de confidentialité
                  </div>
                )}
              </Link>
            </li>

            <li>
              <Link 
                to="/terms-of-service" 
                className={`flex items-center px-4 py-3 ${isActive('/terms-of-service') ? 'bg-emerald-700/30 border-r-4 border-cyan-400' : 'hover:bg-emerald-800/20'} group relative`}
                title="Conditions d'utilisation"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <span className={`ml-3 transition-opacity duration-300 ${
                  isSidebarExpanded ? 'opacity-100' : 'opacity-0'
                } ${isSidebarExpanded ? 'block' : 'hidden'}`}>
                  Conditions d'utilisation
                </span>
                {!isSidebarExpanded && (
                  <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                    Conditions d'utilisation
                  </div>
                )}
              </Link>
            </li>
          </ul>
        </nav>

        {user && (
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <Link 
              to={`/profile/${user.id}`}
              className="flex items-center space-x-3 hover:bg-emerald-800/20 p-2 rounded-lg group relative"
              title={user.displayName || 'Profil'}
            >
              <div className="w-10 h-10 bg-emerald-600 rounded-full flex items-center justify-center">
                {user.displayName?.charAt(0) || '🚀'}
              </div>
              <div className={`overflow-hidden transition-opacity duration-300 ${
                isSidebarExpanded ? 'opacity-100' : 'opacity-0'
              } ${isSidebarExpanded ? 'block' : 'hidden'}`}>
                <p className="font-medium truncate text-emerald-200">{user.displayName || 'Jupipote'}</p>
                <p className="text-xs text-emerald-400 truncate">{user.walletAddress?.substring(0, 10)}...</p>
              </div>
              {!isSidebarExpanded && (
                <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                  {user.displayName || 'Profil'}
                </div>
              )}
            </Link>
          </div>
        )}
      </div>

      {/* Mobile Navigation */}
      <MobileNavigation unreadCount={unreadCount} />

      {/* Main Content */}
      <div className={`transition-all duration-300 ease-in-out pb-20 pt-14 md:pt-0 md:pb-0 ${
        isSidebarExpanded ? 'md:ml-64' : 'md:ml-20'
      }`}>
        {children}
      </div>

      {/* Message Widget pour Desktop uniquement */}
      {shouldShowWidget && (
        <>
          {/* Bouton flottant */}
          {!showMessageWidget && (
            <MessageFloatingButton
              onClick={() => setShowMessageWidget(true)}
              unreadCount={unreadCount}
            />
          )}
          
          {/* Widget de messages */}
          <MessageWidget
            isVisible={showMessageWidget}
            onToggle={() => setShowMessageWidget(false)}
          />
        </>
      )}
    </div>
  );
};

export default Layout;
